/*
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import { RequestsHandlerInstance } from '../utils/RequestsHandler';
import {
  IDefaultEmailPreferenceResponse,
  IEmailPreferencesRepository, IPreferenceResponse
} from '../IEmailPreferencesRepository';
import { IEmailPreferences } from '../../../domain/models/IEmailPreferences';

export default class EmailPreferencesRepository implements IEmailPreferencesRepository {
  private requestsHandler: RequestsHandlerInstance;

  private readonly rootResourcePath: string;

  private readonly apiBaseUrl: string;

  constructor(requestsHandler: RequestsHandlerInstance, rootResourcePath: string, apiBaseUrl: string) {
    this.requestsHandler = requestsHandler;
    this.rootResourcePath = rootResourcePath;
    this.apiBaseUrl = apiBaseUrl;
  }

  getPreferences(application: string): Promise<IPreferenceResponse> {
    return this.requestsHandler.get(
      `${this.apiBaseUrl}/${this.rootResourcePath}/${application}/preferences`
    );
  }

  getDefaults(): Promise<IDefaultEmailPreferenceResponse> {
    return this.requestsHandler.get(
      `${this.apiBaseUrl}/${this.rootResourcePath}/applications?fields=preferenceSchema`
    );
  }

  updatePreferences(application: string, preferences: IEmailPreferences[]): Promise<IPreferenceResponse> {
    return this.requestsHandler.put(
      `${this.apiBaseUrl}/${this.rootResourcePath}/${application}/preferences`,
      { data: preferences }
    );
  }
}
